import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=08fbbd16&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=08fbbd16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbbd16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fbbd16')) {
      api.createRecord('08fbbd16', component.options)
    } else {
      api.reload('08fbbd16', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=08fbbd16&scoped=true&", function () {
      api.rerender('08fbbd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Notifications/Notifications.vue"
export default component.exports